import { createRoot } from "react-dom/client";
import ApolloProvider from "./ApolloProvider";

const root = createRoot(document.getElementById("root"));
root.render(ApolloProvider);
